import { setupInterceptors } from '@operations/app/http-client'
import { setupValidation } from '@operations/app/validation'
import { CraneOperatorLandingContainerUIStore } from '@operations/features/craneOperator/stores/crane-operator-landing-container.ui-store'
import { CraneOperatorNoGeometryUIStore } from '@operations/features/craneOperator/stores/crane-operator-no-geometry.ui-store'
import { CraneOperatorUIStore } from '@operations/features/craneOperator/stores/crane-operator.ui-store'
import { CraneSplitContainerUIStore } from '@operations/features/craneSplit/stores/crane-split-container.ui-store'
import { CraneSplitDialogUIStore } from '@operations/features/craneSplit/stores/crane-split-dialog.ui-store'
import { CraneSplitMessageUIStore } from '@operations/features/craneSplit/stores/crane-split-message.ui-store'
import { SelectCranesDialogUIStore } from '@operations/features/craneSplit/stores/select-cranes-dialog.ui-store'
import { EquipmentOperatorLandingUIStore } from '@operations/features/equipmentOperator/stores/equipment-operator-landing.ui-store'
import { EquipmentOperatorNotificationUIStore } from '@operations/features/equipmentOperator/stores/equipment-operator-notification.ui-store'
import { EquipmentOperatorSearchUIStore } from '@operations/features/equipmentOperator/stores/equipment-operator-search.ui-store'
import { EquipmentOperatorSignalRUIStore } from '@operations/features/equipmentOperator/stores/equipment-operator-signalr.ui-store'
import { EquipmentOperatorStepperUIStore } from '@operations/features/equipmentOperator/stores/equipment-operator-stepper.ui-store'
import { EquipmentOperatorWorkInstructionStepperUIStore } from '@operations/features/equipmentOperator/stores/equipment-operator-work-instruction-stepper.ui-store'
import { EquipmentOperatorWorkInstructionsUIStore } from '@operations/features/equipmentOperator/stores/equipment-operator-work-instructions.ui-store'
import { EquipmentOperatorUIStore } from '@operations/features/equipmentOperator/stores/equipment-operator.ui-store'
import { EquipmentPlanningEquipmentsUIStore } from '@operations/features/equipmentPlanning/stores/equipment-planning-equipments-ui-store'
import { EquipmentPlanningInfoUIStore } from '@operations/features/equipmentPlanning/stores/equipment-planning-info-ui-store'
import { EquipmentPlanningUIStore } from '@operations/features/equipmentPlanning/stores/equipment-planning-ui-store'
import { EquipmentDialogUIStore } from '@operations/features/equipments/stores/equipment-dialog.ui-store'
import { EquipmentFiltersUIStore } from '@operations/features/equipments/stores/equipment-filters.ui-store'
import { EquipmentsUIStore } from '@operations/features/equipments/stores/equipments.ui-store'
import { JobMonitoringDrawerUIStore } from '@operations/features/job/stores/job-monitoring-drawer.ui-store'
import { WorkInstructionFiltersUIStore } from '@operations/features/job/stores/work-instruction-filters.ui-store'
import { WorkInstructionUIStore } from '@operations/features/job/stores/work-instruction.ui-store'
import { ReeferMonitoringDrawerUIStore } from '@operations/features/reeferMonitoring/stores/reefer-monitoring-drawer.ui-store'
import { ReeferMonitoringFiltersUIStore } from '@operations/features/reeferMonitoring/stores/reefer-monitoring-filters.ui-store'
import { ReeferMonitoringUIStore } from '@operations/features/reeferMonitoring/stores/reefer-monitoring.ui-store'
import { TallymanOperationsUIStore } from '@operations/features/tallyman/stores/tallyman-operations.ui-store'
import { EquipmentsVesselVisitUIStore } from '@operations/features/vesselVisitDashboard/stores/equipments-vessel-visit.ui-store'
import { CargoUnitStore } from '@operations/stores/CargoUnitStore'
import { CarrierVisitStore } from '@operations/stores/CarrierVisitStore'
import { ContainerStowageLocationStore } from '@operations/stores/ContainerStowageLocationStore'
import { DataSnapshotStore } from '@operations/stores/DataSnapshotStore'
import { EquipmentStore } from '@operations/stores/EquipmentStore'
import { JobStore } from '@operations/stores/JobStore'
import { ReeferTemperatureStore } from '@operations/stores/ReeferTemperatureStore'
import { TenantConfigStore } from '@operations/stores/TenantConfigStore'
import { WorkAreaStore } from '@operations/stores/WorkAreaStore'
import { WorkInstructionStore } from '@operations/stores/WorkInstructionStore'
import { WorkQueueStore } from '@operations/stores/WorkQueueStore'
import { YardBlockStore } from '@operations/stores/YardBlockStore'
import {
  AppStore,
  AuthStore,
  HubContext,
  MessageBus,
  appStore as appStoreObject,
  authStore as authStoreObject,
} from '@tom-ui/utils'
import { ReactNode, createContext, useContext } from 'react'
import { CoolingOrdersUIStore } from './features/coolingOperator/stores/cooling-oders.ui-store'
import { EquipmentPlanningRailEquipmentsUIStore } from './features/equipmentPlanning/stores/equipment-planning-rail-equipmentsl-ui-store'
import { EquipmentPlanningRailUIStore } from './features/equipmentPlanning/stores/equipment-planning-rail-ui-store'
import { IssueUIStore } from './features/issue/stores/issue.ui-store'
import { ReeferMonitoringFiltersUIStoreV2 } from './features/reeferMonitoring/stores/reefer-monitoring-filters.ui-storeV2'
import { ReeferMonitoringUIStoreV2 } from './features/reeferMonitoring/stores/reefer-monitoring.ui-storeV2'
import { StoppageReasonViewStore } from './features/stoppageReason/stores/stoppageReasonViewStore'
import { HasVisitWorkInstructionAndWorkQueueUIStore } from './features/vesselVisitDashboard/stores/has-visit-wi-wq.ui-store'
import { IsCraneSplitOutdatedUIStore } from './features/vesselVisitDashboard/stores/is-crane-split-outdated.ui-store'
import { EventTypes } from './messages/eventsTypes'
import { GangStore } from './stores/GangStore'
import { HatchCoverMoveStore } from './stores/HatchCoverMoveStore'
import { IssueStore } from './stores/IssueStore'
import { OperationalEquipmentStore } from './stores/OperationalEquipmentStore'
import { RailVisitStore } from './stores/RailVisitStore'
import { ReeferTemperatureStoreV2 } from './stores/ReeferTemperatureStoreV2'
import { ShiftStore } from './stores/ShiftStore'
import { StoppageReasonStore } from './stores/StoppageReasonStore'
import { StoppageStore } from './stores/StoppageStore'

export const messageBus = new MessageBus()
export const hubContext = new HubContext('/operationsHub', messageBus)
const listenedEvents: string[] = [
  EventTypes.CarrierVisitRefresh,
  EventTypes.ReeferTemperatureUpserted,
  EventTypes.WorkInstructionDeleted,
  EventTypes.WorkInstructionFinished,
  EventTypes.WorkQueueUpserted,
  EventTypes.JobUpserted,
  EventTypes.WorkInstructionConfirmed,
  EventTypes.EquipmentsJobRefresh,
  EventTypes.WagonWeightUpdated,
  EventTypes.WorkInstructionJobsUpserted,
  EventTypes.CoolingOrderUpserted,
  EventTypes.WorkInstructionUpserted,
  EventTypes.EquipmentLastPositionOnYard,
  EventTypes.CarrierVisitWorkInstructionUpserted,
  EventTypes.EquipmentUpserted,
  EventTypes.EquipmentDeleted,
  EventTypes.TenantUpserted,
  EventTypes.IssueUpserted,
  EventTypes.HatchCoverMoveUpserted,
  EventTypes.HatchCoverMoveDeleted,
  EventTypes.StoppageReasonUpserted,
  EventTypes.StoppageReasonDeleted,
  EventTypes.StoppageUpserted,
  EventTypes.StoppageDeleted,
  EventTypes.EquipmentAssignmentUpserted,
  EventTypes.EquipmentLastJobUpserted,
  EventTypes.ShiftUpserted,
  EventTypes.ShiftDeleted,
  EventTypes.GangUpserted,
  EventTypes.GangDeleted,
  EventTypes.EquipmentOperatorAssigned,
  EventTypes.CraneSplitGeneratedForVisit,
]
listenedEvents.forEach(c => hubContext.registerPassThroughConnection(c))
hubContext.startConnection()

type IStore = {
  appStore: AppStore
  tenantConfigStore: TenantConfigStore
  cargoUnitStore: CargoUnitStore
  equipmentStore: EquipmentStore
  jobStore: JobStore
  carrierVisitStore: CarrierVisitStore
  railVisitStore: RailVisitStore
  workAreaStore: WorkAreaStore
  workInstructionStore: WorkInstructionStore
  workQueueStore: WorkQueueStore
  yardBlockStore: YardBlockStore
  authStore: AuthStore
  containerStowageLocationStore: ContainerStowageLocationStore
  reeferTemperatureStore: ReeferTemperatureStore
  dataSnapshotStore: DataSnapshotStore
  reeferTemperatureStoreV2: ReeferTemperatureStoreV2
  issueStore: IssueStore
  hatchCoverMoveStore: HatchCoverMoveStore
  stoppageReasonStore: StoppageReasonStore
  stoppageStore: StoppageStore
  operationalEquipmentStore: OperationalEquipmentStore
  shiftStore: ShiftStore
  gangStore: GangStore
}
const appStore = appStoreObject
const tenantConfigStore = new TenantConfigStore(messageBus)
const cargoUnitStore = new CargoUnitStore()
const equipmentStore = new EquipmentStore(messageBus)
const jobStore = new JobStore()
const carrierVisitStore = new CarrierVisitStore(messageBus)
const railVisitStore = new RailVisitStore()
const workAreaStore = new WorkAreaStore()
const workInstructionStore = new WorkInstructionStore()
const workQueueStore = new WorkQueueStore()
const yardBlockStore = new YardBlockStore()
const authStore = authStoreObject
const containerStowageLocationStore = new ContainerStowageLocationStore()
const reeferTemperatureStore = new ReeferTemperatureStore(messageBus, appStore)
const reeferTemperatureStoreV2 = new ReeferTemperatureStoreV2(messageBus, appStore)
const dataSnapshotStore = new DataSnapshotStore()
const issueStore = new IssueStore(messageBus)
const hatchCoverMoveStore = new HatchCoverMoveStore(messageBus)
const stoppageReasonStore = new StoppageReasonStore(messageBus)
const stoppageStore = new StoppageStore(messageBus)
const operationalEquipmentStore = new OperationalEquipmentStore(messageBus)
const shiftStore = new ShiftStore(messageBus)
const gangStore = new GangStore(messageBus)

type IViewStore = {
  craneSplitContainerUIStore: CraneSplitContainerUIStore
  craneSplitDialogUIStore: CraneSplitDialogUIStore
  craneSplitMessageUIStore: CraneSplitMessageUIStore
  selectCranesDialogUIStore: SelectCranesDialogUIStore
  equipmentOperatorUIStore: EquipmentOperatorUIStore
  equipmentOperatorSignalRUIStore: EquipmentOperatorSignalRUIStore
  equipmentOperatorNotificationUIStore: EquipmentOperatorNotificationUIStore
  equipmentOperatorLandingUIStore: EquipmentOperatorLandingUIStore
  equipmentOperatorStepperUIStore: EquipmentOperatorStepperUIStore
  equipmentOperatorWorkInstructionStepperUIStore: EquipmentOperatorWorkInstructionStepperUIStore
  equipmentOperatorSearchUIStore: EquipmentOperatorSearchUIStore
  equipmentOperatorWorkInstructionsUIStore: EquipmentOperatorWorkInstructionsUIStore
  equipmentPlanningEquipmentsUIStore: EquipmentPlanningEquipmentsUIStore
  equipmentPlanningRailEquipmentsUIStore: EquipmentPlanningRailEquipmentsUIStore
  equipmentPlanningInfoUIStore: EquipmentPlanningInfoUIStore
  equipmentPlanningUIStore: EquipmentPlanningUIStore
  equipmentPlanningRailUIStore: EquipmentPlanningRailUIStore
  equipmentDialogUIStore: EquipmentDialogUIStore
  stoppageReasonViewStore: StoppageReasonViewStore
  equipmentFiltersUIStore: EquipmentFiltersUIStore
  equipmentsUIStore: EquipmentsUIStore
  equipmentsVesselVisitUIStore: EquipmentsVesselVisitUIStore
  workInstructionUIStore: WorkInstructionUIStore
  workInstructionFiltersUIStore: WorkInstructionFiltersUIStore
  tallymanOperationsUIStore: TallymanOperationsUIStore
  craneOperatorLandingContainerUIStore: CraneOperatorLandingContainerUIStore
  craneOperatorUIStore: CraneOperatorUIStore
  isCraneSplitOutdatedUIStore: IsCraneSplitOutdatedUIStore
  hasVisitWorkInstructionAndWorkQueueUIStore: HasVisitWorkInstructionAndWorkQueueUIStore
  craneOperatorNoGeometryUIStore: CraneOperatorNoGeometryUIStore
  reeferMonitoringUIStore: ReeferMonitoringUIStore
  reeferMonitoringFiltersUIStore: ReeferMonitoringFiltersUIStore
  reeferMonitoringDrawerUIStore: ReeferMonitoringDrawerUIStore
  reeferMonitoringUIStoreV2: ReeferMonitoringUIStoreV2
  reeferMonitoringFiltersUIStoreV2: ReeferMonitoringFiltersUIStoreV2
  jobMonitoringDrawerUIStore: JobMonitoringDrawerUIStore
  coolingOrdersUIStore: CoolingOrdersUIStore
  issueUIStore: IssueUIStore
}

const workInstructionFiltersUIStore = new WorkInstructionFiltersUIStore(
  equipmentStore,
  workInstructionStore,
)
const workInstructionUIStore = new WorkInstructionUIStore(
  messageBus,
  workInstructionStore,
  workInstructionFiltersUIStore,
  appStore,
)

const craneSplitContainerUIStore = new CraneSplitContainerUIStore(
  workQueueStore,
  workInstructionStore,
  equipmentStore,
  carrierVisitStore,
  containerStowageLocationStore,
  messageBus,
)
const craneSplitDialogUIStore = new CraneSplitDialogUIStore(
  messageBus,
  workQueueStore,
  equipmentStore,
  craneSplitContainerUIStore,
  workInstructionStore,
  carrierVisitStore,
)
const craneSplitMessageUIStore = new CraneSplitMessageUIStore()

const selectCranesDialogUIStore = new SelectCranesDialogUIStore(
  equipmentStore,
  carrierVisitStore,
  workQueueStore,
  workInstructionStore,
  containerStowageLocationStore,
)

const equipmentOperatorLandingUIStore = new EquipmentOperatorLandingUIStore(
  messageBus,
  appStore,
  authStore,
  equipmentStore,
  tenantConfigStore,
  gangStore,
)
const equipmentOperatorSearchUIStore = new EquipmentOperatorSearchUIStore()
const equipmentOperatorUIStore = new EquipmentOperatorUIStore(
  jobStore,
  equipmentStore,
  workInstructionStore,
  equipmentOperatorSearchUIStore,
  equipmentOperatorLandingUIStore,
)
const equipmentOperatorWorkInstructionsUIStore = new EquipmentOperatorWorkInstructionsUIStore(
  workInstructionStore,
  equipmentOperatorSearchUIStore,
  equipmentOperatorLandingUIStore,
  tenantConfigStore,
  gangStore,
)
const equipmentOperatorNotificationUIStore = new EquipmentOperatorNotificationUIStore(
  equipmentOperatorUIStore,
  equipmentOperatorWorkInstructionsUIStore,
)

const equipmentOperatorStepperUIStore = new EquipmentOperatorStepperUIStore(
  cargoUnitStore,
  equipmentStore,
  jobStore,
  appStore,
  tenantConfigStore,
  equipmentOperatorUIStore,
)
const equipmentOperatorSignalRUIStore = new EquipmentOperatorSignalRUIStore(
  messageBus,
  jobStore,
  appStore,
  equipmentOperatorNotificationUIStore,
  equipmentOperatorUIStore,
  equipmentOperatorWorkInstructionsUIStore,
  equipmentOperatorStepperUIStore,
)
const equipmentOperatorWorkInstructionStepperUIStore =
  new EquipmentOperatorWorkInstructionStepperUIStore(
    workInstructionStore,
    appStore,
    equipmentOperatorWorkInstructionsUIStore,
  )

const equipmentPlanningEquipmentsUIStore = new EquipmentPlanningEquipmentsUIStore(
  equipmentStore,
  workAreaStore,
  carrierVisitStore,
  workQueueStore,
  messageBus,
)
const equipmentPlanningRailEquipmentsUIStore = new EquipmentPlanningRailEquipmentsUIStore(
  equipmentStore,
  workAreaStore,
  railVisitStore,
  messageBus,
)
const equipmentPlanningInfoUIStore = new EquipmentPlanningInfoUIStore(
  carrierVisitStore,
  workInstructionStore,
)
const equipmentPlanningUIStore = new EquipmentPlanningUIStore(
  equipmentStore,
  workAreaStore,
  carrierVisitStore,
  workInstructionStore,
  workQueueStore,
  containerStowageLocationStore,
  equipmentPlanningInfoUIStore,
  equipmentPlanningEquipmentsUIStore,
  craneSplitContainerUIStore,
  craneSplitDialogUIStore,
  craneSplitMessageUIStore,
  selectCranesDialogUIStore,
  workInstructionUIStore,
  workInstructionFiltersUIStore,
)

const equipmentPlanningRailUIStore = new EquipmentPlanningRailUIStore(
  equipmentStore,
  workAreaStore,
  workInstructionStore,
  railVisitStore,
  equipmentPlanningRailEquipmentsUIStore,
)
const equipmentDialogUIStore = new EquipmentDialogUIStore(equipmentStore)
const equipmentFiltersUIStore = new EquipmentFiltersUIStore(equipmentStore, yardBlockStore)
const equipmentsUIStore = new EquipmentsUIStore(equipmentStore, equipmentFiltersUIStore)

const stoppageReasonViewStore = new StoppageReasonViewStore(stoppageReasonStore)

const equipmentsVesselVisitUIStore = new EquipmentsVesselVisitUIStore(messageBus, equipmentStore)

const tallymanOperationsUIStore = new TallymanOperationsUIStore(messageBus)

const craneOperatorLandingContainerUIStore = new CraneOperatorLandingContainerUIStore(
  messageBus,
  appStore,
)

const craneOperatorUIStore = new CraneOperatorUIStore(messageBus, appStore)
const craneOperatorNoGeometryUIStore = new CraneOperatorNoGeometryUIStore(messageBus, appStore)
const isCraneSplitOutdatedUIStore = new IsCraneSplitOutdatedUIStore(messageBus)
const hasVisitWorkInstructionAndWorkQueueUIStore = new HasVisitWorkInstructionAndWorkQueueUIStore(
  messageBus,
)

const reeferMonitoringFiltersUIStore = new ReeferMonitoringFiltersUIStore(reeferTemperatureStore)
const reeferMonitoringUIStore = new ReeferMonitoringUIStore(
  reeferTemperatureStore,
  reeferMonitoringFiltersUIStore,
)
const reeferMonitoringDrawerUIStore = new ReeferMonitoringDrawerUIStore(reeferTemperatureStore)

const reeferMonitoringFiltersUIStoreV2 = new ReeferMonitoringFiltersUIStoreV2(
  reeferTemperatureStoreV2,
)
const reeferMonitoringUIStoreV2 = new ReeferMonitoringUIStoreV2(
  reeferTemperatureStoreV2,
  reeferMonitoringFiltersUIStoreV2,
  tenantConfigStore,
)

const jobMonitoringDrawerUIStore = new JobMonitoringDrawerUIStore(
  cargoUnitStore,
  equipmentStore,
  workInstructionStore,
  yardBlockStore,
)

const coolingOrdersUIStore = new CoolingOrdersUIStore(reeferTemperatureStore)

const issueUIStore = new IssueUIStore(issueStore)

export interface IAppStore extends IStore, IViewStore {}

const store: IAppStore = {
  appStore,
  tenantConfigStore: tenantConfigStore,
  cargoUnitStore,
  equipmentStore,
  jobStore,
  carrierVisitStore,
  railVisitStore,
  workAreaStore,
  workInstructionStore,
  workQueueStore,
  yardBlockStore,
  authStore,
  workInstructionUIStore,
  workInstructionFiltersUIStore,
  equipmentOperatorStepperUIStore,
  equipmentOperatorSearchUIStore,
  craneSplitContainerUIStore,
  craneSplitDialogUIStore,
  craneSplitMessageUIStore,
  selectCranesDialogUIStore,
  equipmentOperatorUIStore,
  equipmentOperatorSignalRUIStore,
  equipmentOperatorNotificationUIStore,
  equipmentOperatorLandingUIStore,
  equipmentOperatorWorkInstructionsUIStore,
  equipmentOperatorWorkInstructionStepperUIStore,
  equipmentPlanningEquipmentsUIStore,
  equipmentPlanningRailEquipmentsUIStore,
  equipmentPlanningInfoUIStore,
  equipmentPlanningUIStore,
  equipmentPlanningRailUIStore,
  equipmentDialogUIStore,
  stoppageReasonViewStore,
  equipmentFiltersUIStore,
  equipmentsUIStore,
  equipmentsVesselVisitUIStore,
  tallymanOperationsUIStore,
  containerStowageLocationStore,
  craneOperatorLandingContainerUIStore,
  craneOperatorUIStore,
  isCraneSplitOutdatedUIStore,
  hasVisitWorkInstructionAndWorkQueueUIStore,
  craneOperatorNoGeometryUIStore,
  reeferTemperatureStore,
  reeferMonitoringFiltersUIStore,
  reeferMonitoringUIStore,
  reeferMonitoringDrawerUIStore,
  reeferTemperatureStoreV2,
  reeferMonitoringUIStoreV2,
  reeferMonitoringFiltersUIStoreV2,
  dataSnapshotStore,
  jobMonitoringDrawerUIStore,
  coolingOrdersUIStore,
  issueStore,
  issueUIStore,
  hatchCoverMoveStore,
  stoppageReasonStore,
  stoppageStore,
  operationalEquipmentStore,
  shiftStore,
  gangStore,
}

setupValidation()
setupInterceptors(appStore)

const OperationsContext = createContext<IAppStore>({ ...store })

export const OperationsStoreProvider = ({ children }: { children: ReactNode }) => {
  return <OperationsContext.Provider value={store}>{children}</OperationsContext.Provider>
}

export const useOperationsStore = () => useContext(OperationsContext)
